import positionCalculatorProvider, { CONDITION_POSITION_CALCULATOR } from './PositionCalculatorProvider';
//import slotOrderFunctionsConfig from './slot-order-functions-config.json';
var DefaultSlotArrangementPolicy = /** @class */ (function () {
    function DefaultSlotArrangementPolicy() {
    }
    DefaultSlotArrangementPolicy.getPosition = function (sportId, matchPhase, slot) {
        //const slotType = slot.type;
        //slotType => order functions
        //let orderFunctions = slotOrderFunctionsConfig[sportId];
        //let positionCalculatorTypes = [SLOT_TYPE_POSITION_CALCULATOR];
        /*if (orderFunctions) {
            const slotTypeOrderFunctions = orderFunctions[slotType];
            if (slotTypeOrderFunctions && slotTypeOrderFunctions.length > 0) {
                positionCalculatorTypes = slotTypeOrderFunctions;
            }
        }*/
        return positionCalculatorProvider(CONDITION_POSITION_CALCULATOR)(sportId, matchPhase, slot);
        /*let position = 0;

        for (let i = 0; i < positionCalculatorTypes.length; i++) {
            const positionCalculator = positionCalculatorProvider(positionCalculatorTypes[i]);

            position = positionCalculator(sportId, matchPhase, slot);
        }*/
        //return position;
    };
    return DefaultSlotArrangementPolicy;
}());
export default DefaultSlotArrangementPolicy;



// WEBPACK FOOTER //
// ./src/components/grid/slot-arrangement-policies/index.js